import React from 'react'
import './WarningText.css'

type Props = {
  text: string
}

function WarningText(props: Props) {
  const { text } = props

  return (
    <span className="warning-text">{text}</span>
  )
}

export default WarningText